export enum RangeOptionNameType {
    PRICE = "price",
    PERIOD = "period",
    CONTRIBUTION = "contribution",
    AGE = "age",
    EARNINGS = "earnings",
    AVERAGE_EARNINGS = "average_earnings",
    HOUSEHOLD_EXPENSES = "monthly_household_spendings",
    LOAN_INSTALLMENTS = "other_loans_monthly_payments"
}
